import { render, staticRenderFns } from "./origins-landing.component.vue?vue&type=template&id=9da84c08&scoped=true"
import script from "./origins-landing.component.vue?vue&type=script&lang=ts"
export * from "./origins-landing.component.vue?vue&type=script&lang=ts"
import style0 from "./origins-landing.component.vue?vue&type=style&index=0&id=9da84c08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da84c08",
  null
  
)

export default component.exports